import { useCurrencies } from 'contexts/OptionsContext/useCurrencies';
import { asMoneyWithoutZeros } from 'helpers';
import styles from './PurchaseOrderOptionLabel.module.css';
import { PurchaseOrderOption } from 'Modules/Plans/Finance/PurchaseOrders/hooks/usePurchaseOrderSelect';
import cn from 'classnames';

type Props = {
    option: PurchaseOrderOption;
    isSelected?: boolean;
};

const PurchaseOrderOptionLabel = ({ option, isSelected }: Props) => {
    const { getCurrencyById } = useCurrencies();
    const currency = getCurrencyById(option.currency_id);
    const poNumber = option.number || option.request_reference || '-';

    return (
        <div className={styles.container}>
            <div className={styles.poHeader}>
                <p className={styles.poNumber}>{poNumber}</p>

                <p className={styles.amountLabel}>
                    Available:&nbsp;
                    <strong>
                        {asMoneyWithoutZeros(option.remaining_amount, currency)}&nbsp;/&nbsp;
                        {asMoneyWithoutZeros(option.amount, currency)}
                    </strong>
                </p>
            </div>

            <p className={cn(styles.poDescription, { [styles.selected]: isSelected })}>{option.description || '-'}</p>
            <p className={styles.poTeam}>{option.team?.name || '-'}</p>
        </div>
    );
};

export default PurchaseOrderOptionLabel;
